export default "__VITE_ASSET__D_QgI7Au__"